import { useTranslation } from "react-i18next";
import { GiSniffingDog } from "react-icons/gi";
import { useNavigate } from "react-router-dom";
import ToggleDrawer from "../../contexts/ToggleDrawer";
import usePrimaryColor from "../../hooks/usePrimaryColor";
import BookingModal from "../modals/bookingModalComponents/components/BookingModal";
import BookingModalContext from "../modals/bookingModalComponents/context/BookingModalContext";
import CustomDialog from "../wrappers/CustomDrawer";
import NoClinicWrapper from "../wrappers/NoClinicWrapper";
import FullScreenMessageCore from "./FullScreenMessageCore";

export default function ChooseAClinicFullScreenMessage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const color = usePrimaryColor();

  return (
    <FullScreenMessageCore
      testId="clinic.choose-message"
      button={
        <NoClinicWrapper>
          <ToggleDrawer>
            <CustomDialog
              buttonType={"contained"}
              sx={{ bgcolor: "white" }}
              buttonMessage={t("Book")}
              buttonSize={"large"}
              maxWidth={"lg"}
              testId="clinic.choose-message.book-button"
            >
              <BookingModalContext key={"service-booking-context"}>
                <BookingModal key={"service-booking-modal"} />
              </BookingModalContext>
            </CustomDialog>
          </ToggleDrawer>
        </NoClinicWrapper>
      }
      title={"ComeBackLater"}
      subtitle={"PleasePickAClinicBeforeProceeding"}
      icon={<GiSniffingDog size={100} color={color} />}
      containerPadding={3}
    />
  );
}
